import React from 'react';
import propTypes from 'prop-types';
import { ShieldOff } from 'lucide-react';
import CarrierLucideIcon from 'components/CarrierLucideIcon/CarrierLucideIcon';
import { UPLINE_DISABLED_SECTION_MESSAGE } from 'helpers/carriers/carrierSectionIconLegends';

export default function CarrierSectionIconLegend({
  legends = [],
  showUplineDisabled = false
}) {
  if (!legends.length && !showUplineDisabled) return null;

  return (
    <div className='flex shrink-0 flex-col items-end gap-1.5'>
      {showUplineDisabled && (
        <div className='flex max-w-[240px] items-center justify-end gap-1.5'>
          <span
            className='text-right text-[13px] leading-tight text-grey'
            title={UPLINE_DISABLED_SECTION_MESSAGE}
          >
            {UPLINE_DISABLED_SECTION_MESSAGE}
          </span>
          <ShieldOff
            size={18}
            className='shrink-0 text-semantic-danger'
            aria-hidden
          />
        </div>
      )}
      {legends.map(legend => (
        <div
          key={`${legend.carrierIcon}|${legend.carrierIconColor}|${legend.carrierIconDescription}`}
          className='flex max-w-[240px] items-center justify-end gap-1.5'
        >
          <span
            className='text-right text-[13px] leading-tight text-grey'
            title={legend.carrierIconDescription}
          >
            {legend.carrierIconDescription}
          </span>
          <CarrierLucideIcon
            name={legend.carrierIcon}
            color={legend.carrierIconColor}
            size={18}
          />
        </div>
      ))}
    </div>
  );
}

CarrierSectionIconLegend.propTypes = {
  legends: propTypes.arrayOf(
    propTypes.shape({
      carrierIcon: propTypes.string.isRequired,
      carrierIconColor: propTypes.string,
      carrierIconDescription: propTypes.string.isRequired
    })
  ),
  showUplineDisabled: propTypes.bool
};
